// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/Users/dj3o8/Projects/nerdweb/src/pages/index.js")
}

exports.json = {
  "index.json": require("gatsby-module-loader?name=path---index!/Users/dj3o8/Projects/nerdweb/.cache/json/index.json")
}

exports.layouts = {

}


// WEBPACK FOOTER //
// ./.cache/async-requires.js